import { createSelector } from "@reduxjs/toolkit";
import { sceneSeatUsageSelector } from "@store/sdb-company/sdb-company-selector";
/**
 * Returns how many SCENE seats of the workspace are still free to be given to a member, as the
 * `SCENE_SEAT` constraint of its plan counts them.
 */
export const sceneSeatsAvailableSelector = createSelector(sceneSeatUsageSelector, usage => {
  if (!usage) {
    return 0;
  }
  return Math.max(usage.max - usage.used, 0);
});